import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default function BackdropLoading({ loading = false }) {
  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1, flexDirection:"column" }}
        open={loading}
      >
        <img
          src="./images/brand.png"
          alt="eylul-brand-photo"
          style={{ ml: 5 }}
          width={100}
        />
        <CircularProgress sx={{color:"var(--clr-eylul-orange)"}} />
      </Backdrop>
    </div>
  );
}
